import { defineComponent as _defineComponent } from 'vue'
import { BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  title?: string;
  subtitle?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChartSummary',
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {



return { __sfc: true,BaseText, NebraskaColors }
}

})